import React, { useContext } from 'react';
import { LanguageContext } from '../components/LanguageContext';
import translations from '../locales/about.json';
import { motion } from 'framer-motion';
import aboutImg from '../assets/88.png';   // <-- импорт фона как обычного изображения
import '../styles/About.css';

export default function About() {
    const { language } = useContext(LanguageContext);
    const { title, paragraphs } = translations[language].about;

    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
    };

    const textVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: i => ({
            opacity: 1,
            y: 0,
            transition: { delay: 0.3 + i * 0.2, duration: 0.5 }
        })
    };

    return (
        <section className="about-wrapper">
            <div className="about-image-container">
                <img src={aboutImg} alt="О компании" className="about-image" />
            </div>
            <motion.div
                className="about-card"
                variants={cardVariants}
                initial="hidden"
                animate="visible"
            >
                <h2 className="about-title">{title}</h2>
                {paragraphs.map((p, i) => (
                    <motion.p
                        key={`${language}-${i}`}
                        className="about-text"
                        custom={i}
                        variants={textVariants}
                        initial="hidden"
                        animate="visible"
                    >
                        {p}
                    </motion.p>
                ))}
            </motion.div>
        </section>
    );
}
